import React from 'react';
import UserHelper from '../../../helper/user.js'
import ChildrenRow from './children/row.js'

export default class RenderHelper{
  RenderRegisterButton(self,permission,UserReducer){
    if(!UserHelper.HasPermission(permission,UserReducer)){
      return
    }
    return(
      <div className="float-right">
        <button type="button" className="btn btn-sm btn-primary" onClick={()=> self.props.history.push('/admin/master-asset-registration')}><i className="fa fa-dot-circle-o"></i> Add New Asset</button>
      </div>
    )
  }

  RenderMasterOption(MasterReducer, type=null){
    if(MasterReducer.rs === null){
      return
    }
    let jsx = [];
    if (type !== null) {
      for (let i = 0 ; i < MasterReducer.rs.length;i++) {
        if (MasterReducer.rs[i].Type === type) {
          jsx.push(
            <option key={MasterReducer.rs[i].Alias} value={MasterReducer.rs[i].Alias}>{MasterReducer.rs[i].Name}</option>
          )
          break;
        }
      }
    } else {
      for(var i = 0 ; i < MasterReducer.rs.length;i++){
        jsx.push(
          <option key={MasterReducer.rs[i].Alias} value={MasterReducer.rs[i].Alias}>{MasterReducer.rs[i].Name}</option>
        )
      }
    }
    return jsx;
  }

  /**
   * MasterReducer = object
   * Type = array
   */
  RenderMasterAutoCompleteFilter(MasterReducer, type=[]) {
    let Option = []

    // handling if MasterReducer null
    if(!MasterReducer.rs){
      return false
    }

    if(type.length > 0) {
        for(let i = 0 ; i < MasterReducer.rs.length;i++) {
            for(let j = 0; j < type.length; j++) {
                if (MasterReducer.rs[i].Type === type[j]) {
                    Option.push({
                        value: MasterReducer.rs[i].Alias,
                        label: MasterReducer.rs[i].Name
                    })
                }
            }
        }

    } else {
        for(let i = 0 ; i < MasterReducer.rs.length;i++) {
            Option.push({
                value: MasterReducer.rs[i].Alias,
                label: MasterReducer.rs[i].Name
            })
        }
    }


    return Option
  }

  RenderMasterAutoComplete(MasterReducer, with_key = false){
    if(!MasterReducer.rs ){
      return false
    }
    let OptionAutoComplete = []
    for(let i = 0 ; i < MasterReducer.rs.length;i++){
      if(with_key){
        OptionAutoComplete.push(
          { value: MasterReducer.rs[i].Alias, label: MasterReducer.rs[i].Name }
        )
      }else{
        OptionAutoComplete.push(
          { value: MasterReducer.rs[i].Name, label: MasterReducer.rs[i].Name }
        )
      }
    }
    return OptionAutoComplete
  }

  RenderPagination(Reducer,next_action,previous_action,next_props,previous_props){
    let jsx = [];

    // if(Reducer.previous !== null){
    //   jsx.push(
    //     <li className="page-item" key={'previous'}><a className="page-link" role="button" tabIndex="0" onClick={()=>previous_action(previous_props)}>Previous</a></li>
    //   )
    // }
    if(Reducer.next !== null){
      jsx.push(
        <div><button className="btn btn-primary" onClick={()=>next_action(next_props)}>Load More</button></div>
      )
    }
    return jsx;
  }
  RenderCurrenciesOption(CurrencyReducer){
    if(CurrencyReducer.rs == null){
      return
    }
    var jsx = [];
    for(var i = 0 ; i < CurrencyReducer.rs.length;i++){
        jsx.push(
          <option
            key={CurrencyReducer.rs[i].Abbreviations}
            data-abbr={CurrencyReducer.rs[i].Abbreviations}
            value={CurrencyReducer.rs[i].Alias}
          >
          {CurrencyReducer.rs[i].Abbreviations}
          </option>
        )
    }
    return jsx;
  }
  RenderRecord(Reducer,self){
    if(Reducer.rs === null){
      return
    }
    var rs = []
    for (var i = 0 ; i < Reducer.rs.length;i++){
        rs.push(
          <ChildrenRow key={i} data={Reducer.rs[i]} self={self} UserReducer={self.props.UserReducer} history={self.props.history}/>
        )
    }
    return rs
  }
  RenderTableSort(self,label,callback){
    if(self.state.TableSort.col === label){
      if(self.state.TableSort.asc){
        return(
          <a
            role="button"
            tabIndex="0"
            onClick={()=>callback(self,label)}
            className="MarginRight"
          >
            <i className="fa fa-sort-alpha-asc float-right"></i>
          </a>
        )
      }
      return(
        <a
          role="button"
          tabIndex="0"
          onClick={()=>callback(self,label)}
          className="MarginRight"
        >
          <i className="fa fa-sort-alpha-desc float-right"></i>
        </a>
      )

    }else{
      return(
        <a
          role="button"
          tabIndex="0"
          onClick={()=>callback(self,label)}
          className="unactive-sort MarginRight"
        >
          <i className="fa fa-sort-alpha-asc float-right"></i>
        </a>
      )
    }
  }

}



// WEBPACK FOOTER //
// ./src/App/asset/asset/helper/render.js